module.exports = __webpack_public_path__ + "static/img/course_1.53062765.png";